module.exports = __webpack_public_path__ + "img/degree.458cf1ed.svg";